<template>
  <div
    class="wish-list-item-sku__basic-infomation"
    @click="clickSkuBasicInformation"
  >
    <ImgLazy
      :image-url="imageUrl"
      :alt-text="itemName"
      aspect-ratio="1 / 1"
      :width="80"
      :height="80"
      class="wish-list-item-sku__img-container"
    />
    <div class="wish-list-item-sku__info">
      <div class="wish-list-item-sku__item-info">
        <p class="wish-list-item-sku__brand-name">
          {{ brandName }}
        </p>
        <p class="wish-list-item-sku__item-name">
          {{ itemName }}
        </p>
        <p v-if="itemSkuName" class="wish-list-item-sku__item-sku-name">
          {{ itemSkuName }}
        </p>
      </div>
      <div v-if="hasLimit">
        <p
          v-if="isReachedWantedQuantity"
          class="wish-list-item-sku__wished-quantity--reached"
        >
          受け取りたい個数に達しました
        </p>
        <p v-else-if="isSoldOut" class="wish-list-item-sku__wished-quantity">
          入荷待ち
        </p>
        <p v-else class="wish-list-item-sku__wished-quantity">
          受け取りたい個数：{{ remainingQuantity }} 個
        </p>
      </div>
      <div v-else>
        <p v-if="isSoldOut" class="wish-list-item-sku__wished-quantity">
          入荷待ち
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import ImgLazy from '../images/ImgLazy.vue'

export default {
  components: {
    ImgLazy
  },
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: false,
      default: ''
    },
    brandName: {
      type: String,
      required: true
    },
    itemId: {
      type: Number,
      required: true
    },
    itemSkuId: {
      type: Number,
      required: true
    },
    hasLimit: {
      type: Boolean,
      required: false,
      default: false
    },
    isSoldOut: {
      type: Boolean,
      required: true
    },
    wantedQuantity: {
      type: Number,
      required: false,
      default: 0
    },
    receivedQuantity: {
      type: Number,
      required: false,
      default: 0
    }
  },
  computed: {
    isReachedWantedQuantity() {
      return this.receivedQuantity >= this.wantedQuantity
    },
    remainingQuantity() {
      return this.wantedQuantity - this.receivedQuantity
    }
  },
  methods: {
    clickSkuBasicInformation() {
      this.$emit('click-sku-basic-information', this.itemId, this.itemSkuId)
    }
  }
}
</script>
<style lang="scss" scoped>
.wish-list-item-sku {
  &__basic-infomation {
    display: flex;
    max-width: $small-contents-width;
    gap: 16px;
  }

  &__img-container {
    border-radius: 8px;
    flex-shrink: 0;
  }

  &__info {
    width: 100%;
    overflow-x: hidden;
  }

  &__item-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  &__brand-name {
    @extend %minimal-bold;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__item-name {
    @extend %caption-bold;
    color: $black;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__item-sku-name {
    @extend %caption-bold;
    color: $black;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__wished-quantity {
    @extend %caption-bold;
    color: $primary;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: 4px;

    &--reached {
      @extend %caption-bold;
      color: $gray-1;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-top: 4px;
    }
  }
}
</style>
